import React from 'react';

interface IndexColumnProps {
  value: number;
}

export default React.memo((props: IndexColumnProps) => {
  return <b>{props.value + 1}</b>;
});
